const CITY_NAME_MAP = {
  warszawa: 'Warszawa',
  krakow: 'Kraków',
  wroclaw: 'Wrocław',
  poznan: 'Poznań',
  gdansk: 'Gdańsk',
  lodz: 'Łódź',
  katowice: 'Katowice',
  lublin: 'Lublin',
  szczecin: 'Szczecin',
  bydgoszcz: 'Bydgoszcz',
  rzeszow: 'Rzeszów',
  bialystok: 'Białystok',
  torun: 'Toruń',
};

const TOP_CITY_SLUGS = new Set(['warszawa', 'krakow', 'wroclaw', 'poznan', 'gdansk']);

function titleCaseFallback(value) {
  return String(value || '')
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function getCityLabel(citySlug) {
  const slug = String(citySlug || '').trim().toLowerCase();
  return CITY_NAME_MAP[slug] || titleCaseFallback(slug);
}

export function buildCityPage(citySlug) {
  const city = getCityLabel(citySlug);
  const slug = String(citySlug || '').trim().toLowerCase();
  const isTopCity = TOP_CITY_SLUGS.has(slug);
  const pageUrl = `/rezerwacje/${String(citySlug || '').trim().toLowerCase()}`;

  return {
    slug,
    city,
    path: pageUrl,
    h1: isTopCity
      ? `Darmowy kalendarz wizyt ${city} – odzyskaj pieniądze z prowizji`
      : `Darmowe rezerwacje dla firm w ${city}. 0 zł prowizji, 0 zł za SMS.`,
    title: isTopCity
      ? `Darmowy kalendarz wizyt ${city} - odzyskaj pieniądze z prowizji | ClientWay`
      : `Darmowe rezerwacje dla firm w ${city} - bez konta klienta i 0 zł prowizji | ClientWay`,
    description: `Darmowy kalendarz rezerwacji dla firm w ${city}. 0 zł abonamentu, 0 zł prowizji, 0 zł za SMS i brak konta klienta przy zapisie.`,
    keywords: `darmowy kalendarz ${city}, rezerwacje online ${city}, bez konta klienta, 0 zł abonamentu, 0 zł prowizji, przypomnienia sms`,
    heroLead: isTopCity
      ? `Darmowy kalendarz wizyt ${city}. Klient zapisuje się bez konta, a Ty odzyskujesz pieniądze z prowizji i abonamentów.`
      : `Najlepsze darmowe narzędzie do rezerwacji dla firm w ${city}. Klient zapisuje się bez konta, a Ty nie oddajesz prowizji od swojej pracy.`,
    intro: `Jeśli prowadzisz usługi w ${city}, nie potrzebujesz kolejnego abonamentu ani skomplikowanego formularza. Potrzebujesz kalendarza, który działa 24/7, trzyma wszystko w jednym miejscu i pozwala klientowi zapisać się od razu bez zakładania konta.`,
    sections: [
      {
        title: 'Twój grafik dostępny 24/7',
        text: `Klient zapisuje się do Twojego kalendarza o każdej porze dnia i nocy. Ty widzisz pełne obłożenie bez odbierania telefonu w trakcie pracy w ${city}.`,
      },
      {
        title: 'Automatyczne przypomnienia SMS, które eliminują nieobecności',
        text: 'Przypomnienia SMS i e-mail robią porządek z terminami, więc mniej wizyt przepada i mniej czasu tracisz na ręczne dopominanie się o potwierdzenie.',
      },
      {
        title: 'Własna strona rezerwacji w 5 minut',
        text: 'Masz gotowy link do zapisów, który wrzucisz do social mediów, Google Maps, strony firmowej albo wiadomości do klienta. Klient nie zakłada konta, więc zapis kończy się szybciej.',
      },
    ],
    benefits: [
      'Darmowy system dla usługodawców',
      'Kalendarz online 24/7',
      'Przypomnienia SMS i e-mail',
      'Baza klientów i historia wizyt',
      '0 zł abonamentu, 0 zł prowizji, 0 zł za SMS',
      'Klient zapisuje się bez zakładania konta',
    ],
    caseStudies: [
      {
        title: 'Kosmetyczka',
        quote: 'Przestałam płacić za kalendarz, a klientki dalej zapisują się same. W grafiku jest spokój, a zapis kończy się bez zakładania konta.',
        result: 'Mniej telefonów, mniej chaosu, więcej spokoju w pracy.',
      },
      {
        title: 'Barber',
        quote: 'Największa różnica? Koniec z ręcznym pilnowaniem terminów. Link do zapisów działa, a ludzie rezerwują po godzinach bez żadnego loginu.',
        result: 'Porządek w fotelach i szybsza obsługa stałych klientów.',
      },
      {
        title: 'Fizjoterapeuta',
        quote: 'Pacjenci widzą terminy od razu, a ja mam pełną kontrolę nad kolejnymi wizytami. Bez abonamentu, bez dopłat i bez zakładania konta.',
        result: 'Lepsza organizacja terapii i mniej zapomnianych wizyt.',
      },
    ],
    migrationBox: {
      title: 'Zmień system w 2 minuty',
      text: 'Używasz innego systemu? Pomożemy Ci zaimportować bazę klientów za darmo. Nie trać więcej pieniędzy na prowizje.',
      cta: 'Załóż darmowe konto',
    },
    faqs: [
      {
        question: 'Czy ClientWay jest naprawdę darmowy?',
        answer: 'Tak. Dla usługodawców system działa bez abonamentu, bez prowizji i bez dopłat za SMS.',
      },
      {
        question: 'Czy moje klientki muszą zakładać konto?',
        answer: 'Nie. W ClientWay stawiamy na szybkość. Klientka wybiera termin, podaje numer telefonu i rezerwuje wizytę w 15 sekund. Żadnych haseł, żadnych aplikacji.',
      },
      {
        question: `Czy mogę użyć tego linku jako strony rezerwacji w ${city}?`,
        answer: 'Tak. Link można dodać do social mediów, map, wizytówki lub wysłać klientom bezpośrednio.',
      },
      {
        question: 'Czy klienci mogą zapisywać się poza godzinami pracy?',
        answer: 'Tak. Rezerwacje działają 24/7, także wieczorem i w weekend.',
      },
    ],
  };
}

export const whyFreePage = {
  path: '/dlaczego-za-darmo',
  title: 'Dlaczego ClientWay jest za darmo? | 0 zł abonamentu, 0 zł prowizji',
  description: 'Wyjaśniamy prosto, dlaczego ClientWay jest darmowy dla usługodawców. Bez abonamentu, bez prowizji i bez dopłat za SMS.',
  keywords: 'dlaczego za darmo, darmowy kalendarz rezerwacji, 0 zł abonamentu, 0 zł prowizji, bez opłat za sms',
  h1: 'Dlaczego ClientWay jest za darmo? Bo nie chcemy być kolejnym pośrednikiem od Twojej pracy.',
  heroLead: 'Manifest wolności: bez abonamentu. Bez prowizji. Bez dopłat za SMS. Bez haczyków.',
  intro: 'Budujemy największą bazę usługodawców w Polsce, a nasze koszty utrzymania są niskie dzięki nowoczesnej architekturze. Dzięki temu możesz korzystać z kalendarza bez oddawania procentu od swoich klientów.',
  sections: [
    {
      title: 'Nie płacisz abonamentu',
      text: 'ClientWay nie wymaga miesięcznej opłaty, więc możesz wejść do systemu bez długoterminowego zobowiązania.',
    },
    {
      title: 'Nie oddajesz prowizji od klientów',
      text: 'To Twoi klienci i Twoje pieniądze. System nie zabiera procentu od rezerwacji ani nie dolicza ukrytych opłat za zapis.',
    },
    {
      title: 'Nie dopłacasz za SMS',
      text: 'Automatyczne przypomnienia są częścią produktu, a nie osobnym rachunkiem na końcu miesiąca.',
    },
    {
      title: 'Nie wymagamy konta klienta',
      text: 'Klient zapisuje się szybciej, bo nie musi tworzyć loginu ani przechodzić przez długi proces rejestracji.',
    },
  ],
  noCatchTitle: 'Dlaczego nie ma haczyka?',
  noCatchLead: 'Model opiera się na skali i przyszłych usługach dodatkowych dla większych firm, a podstawowy kalendarz dla małych usługodawców pozostaje darmowy.',
  noCatchPoints: [
    'Podstawowe funkcje kalendarza pozostają bezpłatne dla lokalnych biznesów.',
    'Monetyzacja może pojawić się dopiero w usługach dodatkowych dla większych organizacji.',
    'Wierzymy w wspieranie małych firm, bo to one tworzą wartość w lokalnych społecznościach.',
  ],
  benefits: [
    '0 zł abonamentu',
    '0 zł prowizji',
    '0 zł za SMS',
    'Rezerwacje 24/7',
    'Baza klientów i historia wizyt',
    'Szybki start bez wdrożenia',
  ],
  caseStudies: [
    {
      title: 'Kosmetyczka, która nie chciała kolejnego abonamentu',
      quote: 'Skończyło się płacenie za samo narzędzie do zapisów. Mam kalendarz, przypomnienia i spokój w grafiku.',
      result: 'Mniej kosztów stałych i więcej kontroli nad terminami.',
    },
    {
      title: 'Barber, który miał dość prowizji',
      quote: 'Zamiast oddawać część przychodu platformie, trzymam wszystko u siebie. Klienci dalej zapisują się sami.',
      result: 'Budżet zostaje w salonie, a rezerwacje działają normalnie.',
    },
    {
      title: 'Fizjoterapeuta, który potrzebował porządku',
      quote: 'Najbardziej cenię to, że nie mam dodatkowej faktury za SMS-y. Terminy mam pod kontrolą, a pacjenci są poinformowani.',
      result: 'Lepsza organizacja bez ukrytych kosztów.',
    },
  ],
  comparisonTitle: 'Porównanie kosztów',
  comparisonLead: 'Najprościej widać to w pieniądzach i w liczbie kliknięć potrzebnych do rezerwacji.',
  comparisonRows: [
    { label: 'Abonament', clientWay: '0 zł', paidSystem: 'Stała miesięczna opłata' },
    { label: 'Prowizja od klientów', clientWay: '0 zł', paidSystem: 'Procent od każdej rezerwacji' },
    { label: 'Opłata za SMS', clientWay: '0 zł', paidSystem: 'Dodatkowy koszt w cenniku' },
    { label: 'Konto klienta', clientWay: 'Nie wymagane', paidSystem: 'Często wymagane' },
    { label: 'Start', clientWay: 'W kilka minut', paidSystem: 'Często dłuższe wdrożenie' },
  ],
  cities: ['warszawa', 'krakow', 'wroclaw', 'poznan', 'gdansk', 'lodz'],
  faqs: [
    {
      question: 'Gdzie jest haczyk?',
      answer: 'Nie ma haczyka. System jest darmowy dla usługodawców i ma po prostu pomagać w ogarnianiu zapisów.',
    },
    {
      question: 'Czy to oznacza, że później pojawi się abonament?',
      answer: 'Nie obiecujemy zmian bez informacji. Na tej stronie komunikujemy aktualny model: 0 zł dla usługodawców.',
    },
    {
      question: 'Czy mogę zacząć bez konfiguracji?',
      answer: 'Tak. Start jest szybki, a link do rezerwacji możesz zacząć używać od razu.',
    },
  ],
  manifestNotes: [
    'Jesteśmy darmowi, bo nie chcemy być kolejnym pośrednikiem, który zabiera procent od Twojej ciężkiej pracy.',
    'Nie pobieramy abonamentu, nie pobieramy prowizji i nie pobieramy dopłat za SMS.',
    'Nasza architektura pozwala utrzymać koszty nisko, a Ty zachowujesz pełną kontrolę nad swoim biznesem.',
  ],
};

export const featuredCitySlugs = whyFreePage.cities;
